export enum ApiErrorCodeEnum {
  Undefined = 0,
  ResourceNotFound = 1000,
  NoDataFound = 1001,
  InvalidMethodCall = 1002,
  ValidationFailed = 1003,
  AuthorizationFailed = 1004,
  AuthenticationFailed = 1005,
  ContextFailed = 1006,
  ClientNotAllowedForUser = 3003,
  InvalidToken = 3004
}

export type ApiErrorCodesEnumType = keyof typeof ApiErrorCodeEnum;
